import Work1 from '../assets/works/work1.png';
import Work2 from '../assets/works/work2.png';
import Work3 from '../assets/works/work3.png';
import Work4 from '../assets/works/work4.png';
import Work5 from '../assets/works/work5.png';
import Work6 from '../assets/works/work6.png';
import Work7 from '../assets/works/work7.png';
import Work8 from '../assets/works/work8.png';
import Work9 from '../assets/works/work9.png';
import Work10 from '../assets/works/work10.png';
import Work11 from '../assets/works/work11.png';

export const projectsData = [
          {
                    id: 1,
                    image: Work1,
                    title: "Job Onboard",
                    category: "MERN stack",
                    live: "https://job-onboard.web.app",
                    client: "https://github.com/Team-Code-Samurai/Job-Onboard-Client",
                    server: "https://github.com/Team-Code-Samurai/Job-Onboard-Server",
          },
          {
                    id: 2,
                    image: Work2,
                    title: "Gadgets Emporium",
                    category: "MERN stack",
                    live: "https://gadgets-emporium.web.app",
                    client: "https://github.com/kiron0/gadgets_emporium",
                    server: "https://github.com/kiron0/gadgets_emporium_server",
          },
          {
                    id: 3,
                    image: Work3,
                    title: "K Task To Do",
                    category: "MERN stack",
                    live: "https://k-task-todo.web.app",
                    client: "https://github.com/kiron0/To-Do-Client",
                    server: "https://github.com/kiron0/To-Do-Server",
          },
          {
                    id: 4,
                    image: Work4,
                    title: "Wonder Automotive Cars",
                    category: "MERN stack",
                    live: "https://wonder-automotive-cars.web.app",
                    client: "https://github.com/kiron0/wonder_automotive_cars",
                    server: "https://github.com/kiron0/wonder_automotive_cars_server",
          },
          {
                    id: 5,
                    image: Work5,
                    title: "Github User Details",
                    category: "frontend",
                    live: "https://github-user-details.vercel.app",
                    client: "https://github.com/kiron0/github-user-details",
          },
          {
                    id: 6,
                    image: Work6,
                    title: "The Users API",
                    category: "backend/API",
                    live: "https://user-api-vyxj.onrender.com",
                    server: "https://github.com/kiron0/node-acc-1",
          },
          {
                    id: 7,
                    image: Work7,
                    title: "The Tours API",
                    category: "backend/API",
                    live: "https://tours-api.up.railway.app",
                    server: "https://github.com/kiron0/node-acc-2",
          },
          {
                    id: 8,
                    image: Work8,
                    title: "Mini Portfolio",
                    category: "frontend",
                    live: "https://mini-portfolio-kiron.vercel.app",
                    client: "https://github.com/kiron0/mini-portfolio",
          },
          {
                    id: 9,
                    image: Work9,
                    title: "Analog Clock",
                    category: "frontend",
                    live: "https://neuclock.pages.dev",
                    client: "https://github.com/kiron0/analog_clock",
          },
          {
                    id: 10,
                    image: Work10,
                    title: "Stopwatch",
                    category: "frontend",
                    live: "https://stopwatch-ts.vercel.app",
                    client: "https://github.com/kiron0/stopwatch",
          },
          {
                    id: 11,
                    image: Work11,
                    title: "Foodi Zone",
                    category: "frontend",
                    live: "http://foodi-zone.web.app",
                    client: "https://github.com/kiron0/foodi-zone",
          },
];

export const projectsNav = [
          {
                    name: "all",
          },
          {
                    name: "MERN stack",
          },
          {
                    name: "frontend",
          },
          {
                    name: "backend/API",
          }
];